import { User } from "../user/user.model";
import { Client } from "../client/client.model";
import { Rate } from "./rate-type";
import { Carrier } from "../carrier/carrier.model";
import { WeightBracketName } from "../shared/weight-bracket/weight-bracket-name.type.const";
import { RateLtlRoute } from "./rate-flat-route-list/rate-ltl-route.model";
import { RateLocation } from "./rate-location/rate-location.type";
import { BaseLinkedRate } from "./rate-base-linked.model";
import { WeightBracketPrices } from "../shared/weight-bracket/weight-bracket-prices.model";
import { Company } from "app/company/company.model";

export class LtlRate extends BaseLinkedRate {
  constructor(
    protected id: number,
    protected name: string,
    protected discriminator: string,
    protected createdBy?: User,
    protected updatedBy?: User,
    protected createdAt?: Date,
    protected updatedAt?: Date,
    protected type?: string,
    protected source?: string,
    protected status?: string,
    protected internalNote?: string,
    protected externalNote?: string,
    protected pmNote?: string,
    protected comment?: string,
    protected deepLink?: string,
    protected carrier?: Carrier,
    protected validity?: Date[],
    protected contractNumber?: string,
    protected restrictedClients?: Client[],
    protected restrictedUsers?: User[],
    protected rootParent?: Rate,
    protected flatRateRoutes?: RateLtlRoute[],
    protected originLocation?: RateLocation,
    protected destinationLocation?: RateLocation,
    public debugInfo?: string,
    public currency?: string,
    public ldm?: number,
    public cbm?: number,
    public ldmThreshold?: number,
    public ldmWidthThreshold?: number,
    public ldmHeightThreshold?: number,
    public ldmLengthThreshold?: number,
    public lengthThreshold?: number,
    public lengthExtraCharge?: number,
    public lengthPercentageExtraCharge?: number,
    public lengthValueExtraCharge?: number,
    public minWeight?: number,
    public maxWeight?: number,
    public minTaxWeight?: number,
    public maxTaxWeight?: number,
    public maxLength?: number,
    public maxHeight?: number,
    public maxWidth?: number,
    public maxLW?: number,
    public maxLWH?: number,
    public minLength?: number,
    public minHeight?: number,
    public minWidth?: number,
    public minLW?: number,
    public minLWH?: number,
    public minMargin?: number,
    public maxMargin?: number,
    public availableOnline?: boolean,
    public domestic?: boolean,
    public availableWeightBrackets?: WeightBracketName[],
    public hiddenMarkup?: number,
    public companies?: Company[],
    public pickupRate?: Rate,
    public deliveryRate?: Rate,
    public weightBracketMargins?: WeightBracketPrices,
    public isInvalid?: boolean,
    // TODO: We should consider a new model LtlFreightRate for this
    protected chargeableWeightPrice?: number,
    protected chargeableWeightMargin?: number,
    protected noMarginPrice?: number,
    protected departureDate?: Date,
    protected deliveryDate?: Date,
  ) {
    super(
      id,
      name,
      discriminator,
      createdBy,
      updatedBy,
      createdAt,
      updatedAt,
      type,
      source,
      status,
      internalNote,
      externalNote,
      pmNote,
      comment,
      deepLink,
      carrier,
      validity,
      currency,
      originLocation,
      destinationLocation,
      contractNumber,
      restrictedClients,
      restrictedUsers,
      rootParent,
    );
  }

  public get isInvalidMessage() {
    return this.isInvalid ? "PD rate not valid" : false;
  }

  public getCurrency() {
    return this.currency;
  }

  public getFlatRateRoutes() {
    return this.flatRateRoutes;
  }

  public setFlatRateRoutes(flatRateRoutes): void {
    this.flatRateRoutes = flatRateRoutes;
  }

  public setCurrency(param: string): void {
    this.currency = param;
  }

  public getChargeableWeightPrice(): number {
    return this.chargeableWeightPrice;
  }
  public setChargeableWeightPrice(value: number) {
    this.chargeableWeightPrice = value;
  }

  public getChargeableWeightMargin(): number {
    return this.chargeableWeightMargin;
  }
  public setChargeableWeightMargin(value: number) {
    this.chargeableWeightMargin = value;
  }

  public getNoMarginPrice(): number {
    return this.noMarginPrice;
  }
  public setNoMarginPrice(value: number) {
    this.noMarginPrice = value;
  }

  public getDeliveryDate(): Date {
    return this.deliveryDate;
  }

  public getDepartureDate(): Date {
    return this.departureDate;
  }

  public getCompanies(): Company[] {
    return this.companies;
  }

  public get companyName(): string {
    if (this.companies && this.companies.length > 0) {
      return this.companies.map((company) => company.name).join(", ");
    }

    return "";
  }

  public setCompanies(param: Company[]): void {
    this.companies = param;
  }

  public isValid(): boolean {
    return !!this.name && !!this.carrier && !!this.validity;
  }
}
